import { FormField } from 'components/form';
import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';
import StatusLabel from 'components/status-label/StatusLabel';
import React from 'react';
import { useCountries } from './helpers';

export function EntertainmentVideoCountries({
  countries: selectedCountries,
  isEditMode = false,
  onCountriesChange
}: {
  countries: Array<string>,
  isEditMode?: boolean,
  onCountriesChange?: (countries: Array<string>) => void
}) {
  const countries = useCountries();

  if (isEditMode) {
    const items = countries.map((country) => ({
      label: country.toUpperCase(),
      value: country,
      identifier: country,
      isDisabled: false,
      isFocused: false,
      isSelected: selectedCountries.includes(country)
    }));

    return (
      <FormField
        direction="column"
        showRequiredMark={false}
        showValidationIcon={false}
      >
        <MixedSelectDropdown
          name="published-countries"
          className="realm-outfit-details-edit__compact-select"
          items={items}
          withMulti
          withRemovable
          withSortable
          withCheckboxes
          withSelectAll
          onItemsToggle={(_, __, addedItem) => {
            if (addedItem?.value) {
              onCountriesChange?.(
                [...selectedCountries, addedItem.value].sort()
              );
            }
          }}
          onItemsToggleAll={() => {
            onCountriesChange?.([...countries]);
          }}
          onItemsRemove={(_, __, removedItem) => {
            if (removedItem?.value) {
              onCountriesChange?.(
                selectedCountries.filter(
                  (country) => country !== removedItem.value
                )
              );
            }
          }}
          onItemsRemoveAll={() => {
            onCountriesChange?.([]);
          }}
        />
      </FormField>
    );
  }

  if (selectedCountries.length === 0) {
    return <span>–</span>;
  }

  return (
    <div style={{ display: 'flex', gap: '6px', flexFlow: 'row wrap' }}>
      {selectedCountries
        .slice()
        .sort()
        .map((country) => (
          <StatusLabel
            key={country}
            label={country.toUpperCase()}
            type="neutral"
            size="small"
          />
        ))}
    </div>
  );
}
